import p from 'x/config/platform-specific'

const XDocumentDropzone = p.comp.getXDocumentDropzone()

export default XDocumentDropzone
